import { useCallback, useEffect, useState } from "react";
import Col from "react-bootstrap/esm/Col";
import Row from 'react-bootstrap/Row';
import { listLicenseLinks } from "../../../services/service";
import { ActionTable } from "../../ActionTable/ActionTable";
import BtnAddLicense from "../BtnAddLicense";
import BtnAddLicenseType from "../BtnAddLicenseType";
import DeleteLicense from "../DeleteLicense";
import LicenseLinkFilter from "../LicenseLinkFilter";
import { handleDownloadLicense } from '../../../services/utils';
import dateFnsFormat from 'date-fns/format';

const defaultResponse = {
  count: 0, results: [], next: null, previous: null
}

export default function LicenseLinks(props) {
  const { tabIndex } = props;
  const [licenseLinksData, setLicenseLinksData] = useState(defaultResponse);
  const [loading, setLoading] = useState(true);
  const [currentLicenseLinkPage, setCurrentLicenseLinkPage] = useState(0);
  const [currentLicenseLinkPageSize, setCurrentLicenseLinkPageSize] = useState(25);
  const [licenseLinkFilters, setLicenseLinkFilters] = useState({ expand: "hardware,license.license_type" })
  const [licenseData, setLicenseData] = useState({})
  const [deleteModal, setDeleteModal] = useState(false)

  const licenseHwLinkColumnsMap = {
    id: "ID",
    license: "ID da Licença",
    hardware: "Hardware",
    license_type: "Modelo de Licença",
    created_at: "Data de Criação",
  }

  const listLicenseLinksFn = useCallback(() => {
    setLoading(true);
    listLicenseLinks(currentLicenseLinkPage + 1, currentLicenseLinkPageSize, licenseLinkFilters)
      .then((response) => {
        response.data.results.map((value) => {
          value['created_at'] = dateFnsFormat(new Date(value.created_at), 'dd/MM/yy HH:mm')
          value["hardware"] = !!value.hardware.name ? value.hardware.name : value.hardware
          value["license_type"] = !!value.license.license_type ? value.license.license_type.name : "N/A"
          value["license"] = !!value.license.id ? value.license.id : value.license
          return value
        })
        console.log(response)
        setLicenseLinksData(response.data)
      })
      .catch((error) => {
        // TODO: Add an alert notifying the user about this error.
        console.log(error)
      })
      .finally(setLoading(false))
  }, [currentLicenseLinkPage, currentLicenseLinkPageSize, tabIndex])

  const handleLicenseDelete = (valueModel) => {
    setDeleteModal(true)
    setLicenseData(valueModel)
  }

  useEffect(() => {
    listLicenseLinksFn()
  }, [currentLicenseLinkPage, currentLicenseLinkPageSize, tabIndex])

  const onLicenseChanged = (value) => {
    listLicenseLinksFn()
  }

  const onPageChange = (newPage) => {
    setCurrentLicenseLinkPage(newPage)
  }

  const onPageSizeChange = (newPageSize) => {
    setCurrentLicenseLinkPage(0);
    setCurrentLicenseLinkPageSize(newPageSize)
  }

  const handleSeeMoreLicense = (valueData) => {
    setLicenseData(valueData)
    window.open(`/licenses/${valueData.license}`, '_blank')
  }


  return (
    <Row>
      <DeleteLicense
        openModal={deleteModal}
        setOpenModal={setDeleteModal}
        licenseData={licenseData}
        onLicenseChanged={onLicenseChanged}
        tableIndex={1}
      />
      <Col lg={9}>
        <LicenseLinkFilter
          pageSize={currentLicenseLinkPageSize}
          setLicenseLinksData={setLicenseLinksData}
          loading={loading}
          setLoading={setLoading}
          setFilters={setLicenseLinkFilters}
        />
        <ActionTable
          title="Licenças Vinculadas"
          enableCheck
          currentPage={currentLicenseLinkPage}
          pageSize={currentLicenseLinkPageSize}
          pageSizeOptions={licenseLinksData.count < 10 ? [10]
            :
            licenseLinksData.count < 25
              ? [10, 25]
              : [10, 25, 40]
          }
          count={licenseLinksData.count}
          columns={Object.keys(licenseHwLinkColumnsMap)}
          columnsMap={licenseHwLinkColumnsMap}
          rows={licenseLinksData.results}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          onEditSelected={(licenseData) => console.log("Edit Row " + licenseData)}
          onDeleteSelected={(licenseData) => handleLicenseDelete(licenseData)}
          setDownloadLicenseIcon={true}
          onDownloadLicense={((licenseData) => handleDownloadLicense(licenseData))}
          setHideEditButton={false}
          setSeeMoreLicenseIcon={true}
          onSeeMoreLicense={(licenseData) => handleSeeMoreLicense(licenseData)}
        />
      </Col>
      <Col lg={3}>
        <BtnAddLicense onLicenseCreated={onLicenseChanged} />
        <BtnAddLicenseType
          sx={{ marginTop: 1 }}
          onLicenseCreated={onLicenseChanged}
        />
        {/* <BtnLinkLicense /> */}
      </Col>
    </Row>
  )
}